import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { combineLatest } from 'rxjs';

import { TransportOrderView } from '../../../models/transport-order-view.model';
import { Transporter } from '../../../models/transporter.model';

import { CurrentDataService } from '../../../services/current-data-service';

@Component({
  selector: 'jhi-track-and-trace-standalone',
  templateUrl: './track-and-trace-standalone.component.html',
})
export class TrackAndTraceStandaloneComponent implements OnInit {

  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly currentDataService = inject(CurrentDataService);

  public transport!: TransportOrderView;
  public transporter!: Transporter;


  public ngOnInit(): void {
    combineLatest([
      this.currentDataService.getCurrentTransporter(),
      this.activatedRoute.data
    ]).subscribe(([transporter, data]) => {
      this.transporter = transporter!;
      this.transport = data['transport'] as TransportOrderView;
    });
  }
}